import { ItemMov, Movimentacao } from "../../mov.model";
import { Select as ViewList } from "../../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";

import { formatMoney, isEmpty } from "../../../../services/utils";
import { DoNotDisturb, ListAlt, ListSharp, Sell } from "@mui/icons-material";
import { TipoMovDesc } from "../../../../data.types";


const getTypePreco = (mov:Movimentacao, itemMov:ItemMov) => {
    if(mov.tipo_mov.descricao === TipoMovDesc.PEDIDO || mov.tipo_mov.descricao === TipoMovDesc.VENDA ){
        if(itemMov.item.tabela_preco){
            switch(itemMov.item.tabela_preco.type as any){
                case "tabelapreco": return <ListAlt titleAccess="Preço da tabela de preço" />;
                case "convenio" :   return <Sell titleAccess={`Preço do convênio`} sx={{ alignSelf: "center" }} color="info" />;
                default: return <DoNotDisturb titleAccess="Origem do preço não definido"/> ;
            }
        } else {
            return '';
        }
    } else {
        return '';
    }
}

const getColumns = (mov:Movimentacao): GridColDef[] => {
    return [
        { field: 'item.codigo', headerName: 'Cód.', flex: 1, valueGetter: (value, row: ItemMov) => row.item.codigo },
        { field: 'item.descricao', headerName: 'Descricão', flex: 4, valueGetter: (value, row: ItemMov) => (row.item.info_dt_validade && row.ano_validade) ? row.item.descricao + " - Val. " + row.ano_validade : row.item.descricao },
        { field: 'qt', headerName: 'Qtde.', flex: 2 },
        { field: 'valor', headerName: 'Preço', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
        { field: 'total', headerName: 'total', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
        { field: 'item.tabela_preco.type', headerName: '', flex: 1, renderCell: (prm) => getTypePreco(mov,prm.row) },
    ]
}

interface ItemMovListProps {
    mov: Movimentacao,
    handleAlterar: (row: ItemMov) => any
    handleAddItem: () => any
    showButtonNew: boolean
    handleClose?:()=>any
}

export function ItemMovList(props: ItemMovListProps) {
    const { mov, handleAlterar, handleAddItem, showButtonNew,handleClose } = props



    const List = () => {
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={`Itens ${!isEmpty(mov._id) ? mov.tipo_mov.descricao.toLowerCase() : "da Movimentação"}`}
                row={mov}
                showAlert={false}
                closeAlert={() => { }}
                msg={""}
                status={""}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={false}
                fontSize={14}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={getColumns(mov)}
                rows={mov.itens}
                loading={false}
                setRow={handleAlterar}
                changeList={""}
                variantToobar="dense"
                buttonNew={{
                    show: showButtonNew,
                    onClick: handleAddItem
                }}
                buttonRefresh={{
                    show: false,
                    onClick: () => { }
                }}
                handleClose={handleClose}
                showButtonBack={false}
                ListItemTextPrimary={(row: ItemMov) => <Typography component={"span"}>{row.item.descricao}</Typography>}
                ListItemTextSecondary={(row: ItemMov) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>Qtde: {formatMoney(row.qt)}</Typography>
                        <Typography component={"span"}>{formatMoney(row.valor)}</Typography>
                        <Typography component={"span"}>{formatMoney(row.total)}</Typography>
                    </Box>
                }
            />
        )
    }

    return (
        <div className="modulo">
            <List />
        </div>
    )

}

